import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { getSection } from 'app/utils'
import { SelectLoading } from "app/components/loading"
import { PACKAGES_URL } from 'app/@common/constants'
import { getAppUserData } from "app/@utils";


export default function SelectConnectivities({ ...props }) {
    
    const section = getSection(window.location.href)
    const { role } = getAppUserData()

    if (role !== 'admin' && section !== 'packages') return <SelectLoading />
    if (!props.date) return <SelectLoading />
    
    const myProps = {
        urlAjax: PACKAGES_URL.ROUTES,
        placeholder: 'All routes',
        icon: { icon: 'plane' },
        isMulti: false,
        firstSelect: true,
        isClearable: false,
        method: 'POST',
        extraParams: {
            dateRange: props.date,
            ...props.refresh && { refresh_cache: props.refresh },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...'id_main_hotel' in props && { id_main_hotel: props.id_main_hotel },
            ...props.date === 'custom' && {
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            }
        },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}